<template>
  <div class="billing-details">
    <detail-cell
      v-for="item in data"
      :key="item.bizOrderNo"
      :data="item"
      :status="status"
      @refresh="$emit('refresh')"
      @calculate="handleCalculate"
      @change-record="showChangeRecord"
    >
    </detail-cell>
    <change-record :visible.sync="visibleRecord" :data="recordData"></change-record>
  </div>
</template>

<script>
import NP from 'number-precision'
import DetailCell from './detail-cell'
import ChangeRecord from './change-record'
import { calculateWithUnit } from '@/common/utils/calculate.js'

export default {
  components: { ChangeRecord, DetailCell },
  props: {
    data: Array,
    status: [String, Number]
  },
  data() {
    return {
      visibleRecord: false,
      recordData: null
    }
  },
  methods: {
    showChangeRecord(item) {
      this.recordData = { id: item.id }
      this.visibleRecord = true
    },
    handleCalculate() {
      let totalQuantity = 0
      let totalWeight = 0
      let totalAmount = 0
      this.data.forEach(p => {
        totalQuantity = NP.plus(totalQuantity, p.$totalQuantity)
        totalWeight = NP.plus(totalWeight, p.$totalWeight)
        totalAmount = NP.plus(totalAmount, p.$totalAmount)
      })
      this.totalQuantity = totalQuantity
      this.totalWeight = totalWeight
      this.totalAmount = totalAmount
      this.$emit('calculate', { totalQuantity, totalWeight, totalAmount })
    }
  }
}
</script>

<style lang="scss">
.billing-details {
  .el-input {
    &.is-disabled {
      .el-input__inner {
        border-radius: 0;
        background-color: #ffffff;
        border-color: #ffffff;
        cursor: pointer;
        &:hover {
          border-color: #ffffff;
          background: #ffffff;
        }
      }
    }

    .el-input__inner {
      border-radius: 0;
      background-color: #fcfcfc;
      border-color: #dcdfe6;
      text-align: center;
      color: #333333;
      cursor: pointer;

      &:hover {
        border-color: #c0c4cc;
        background: #fcfcfc;
      }

      &:focus {
        outline: none;
        border-color: #f0242e;
        background: #fcfcfc;
      }
    }
  }
}
</style>
